import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/pagar-envio/page.tsx");
